import React from 'react';
import styled from 'styled-components';
import SanityImage from 'gatsby-plugin-sanity-image';
import breakpoints from '@rsc/ui-components/breakpoints';

const SupportArticleImageWrapper = styled.div`
  img {
    display: block;
    margin: auto;
    max-width: 50%;
    max-height: 50%;
  }

  @media (max-width: ${breakpoints.md}) {
    img {
      height: 300px;
      margin-bottom: 0.25em;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      width: 100%;
    }
  }
`;

function SupportArticleImage({ image }) {
  return (
    <SupportArticleImageWrapper>
      <SanityImage asset={image?.asset} alt={image?.alt} />
    </SupportArticleImageWrapper>
  );
}

export default SupportArticleImage;
